import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardContent } from '../components/shared';
import { useNavigationService } from '../stores';

const NotFound: React.FC = observer(() => {
  const { t } = useTranslation();
  const navigationService = useNavigationService();

  const handleGoBack = () => {
    navigationService.goBack();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-start justify-center p-4 pt-20">
      <Card className="max-w-md w-full shadow-xl">
        <CardContent className="p-8 text-center">
          {/* Icon */}
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <span className="text-3xl">🔍</span>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            {t('errors.pageNotFound')}
          </h1>

          {/* Actions */}
          <div className="space-y-3">
            <Button
              disabled
              className="w-full bg-gray-300 text-gray-500 cursor-not-allowed"
            >
              {t('errors.goHome')}
            </Button>

            <Button variant="outline" onClick={handleGoBack} className="w-full">
              {t('errors.goBack')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
});

export default NotFound;
